import Swal from "sweetalert2";
import { parseUnscrambleFromTheme } from "../pages/game/unscrambleUtils";

/** Keep in sync with admin themeupdate minimums. */
const UNSCRAMBLE_MIN_PAIRS = 2;

function collectUnscrambleMissing(themeData, missing) {
  const pairs = parseUnscrambleFromTheme(themeData);
  if (pairs.length < UNSCRAMBLE_MIN_PAIRS) {
    missing.push(
      `Unscramble: need at least ${UNSCRAMBLE_MIN_PAIRS} complete question/answer pairs (found ${pairs.length})`
    );
  }
}

/**
 * Validate that themeData has complete content for the Unscramble stage.
 * @returns {{ ok: boolean, missing: string[] }}
 */
export function validateThemeStageData(themeData) {
  if (!themeData || typeof themeData !== "object") {
    return {
      ok: false,
      missing: ["Theme data is missing. Please configure the theme before starting the game."],
    };
  }

  const missing = [];
  collectUnscrambleMissing(themeData, missing);

  return { ok: missing.length === 0, missing };
}

/** Shared Swal for incomplete theme stage data. */
export function fireThemeStageDataMissingSwal(missing = []) {
  const missingList = missing.map((item) => `<li>${item}</li>`).join("");
  return Swal.fire({
    icon: "warning",
    title: "These are missing",
    html: `<p>Please fill all stage data before starting the game.</p><ul style="text-align:left;margin:12px 0 0;padding-left:18px;max-height:240px;overflow:auto;">${missingList}</ul>`,
    confirmButtonText: "OK",
    allowOutsideClick: false,
    allowEscapeKey: false,
  });
}
